import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import ToolsGeneralContent from '@v2/pages/machines/modules/now/components/Tools/components/ToolsGeneralContent';
import { connect } from 'react-redux';
import { PANEL_VIEW_MODE_WIDTH, SCREEN_PADDING_HORIZONTAL_FOR_ITEM } from '@v2/pages/common/constants/base.constants';
import { updateHeaderConfig } from '@reducers/details';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';
import { getToolById } from '@reducers/clampingTools';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { getNCFileById } from '@reducers/manufacture';
import { isWeb } from '@helpers';

interface ToolsDetailsToolsProps {}

const ToolsDetailsToolsComponent: FC<ToolsDetailsToolsProps> = ({ getToolById, updateHeaderConfig, clampingToolsLoaded, getNCFileById }) => {
  const title = useTitle();

  const { refetchTools } = useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
  });

  return (
    <DetailsPageWrapper title={title.tool}>
      <View style={{ flex: 1, paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}>
        <ToolsGeneralContent
          loading={!clampingToolsLoaded}
          maxDetailsWidth={PANEL_VIEW_MODE_WIDTH}
          bg={!isWeb ? 'Background/Light/Field on Panel' : 'Background/Light/Field'}
          refetchTools={refetchTools}
        />
      </View>
    </DetailsPageWrapper>
  );
};

const ToolsDetailsTools = connect(({ clampingTools: { loaded } }) => ({ clampingToolsLoaded: loaded }), {
  updateHeaderConfig,
  getToolById,
  getNCFileById,
})(ToolsDetailsToolsComponent);

export { ToolsDetailsTools };
